import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import getters from './getters';
import mutations from './mutations';
import payload from '~/config/sharedEnv';
export var state = function state() {
  return {
    payload: payload
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations
};